import React from 'react';

import { SAVING_OVERLAY_CLASS } from 'utils/mousetrap-react';
import { useStepsContext } from './steps-context';

// the saving overlay's class: it blocks the mouse and the workspace hotkeys alike
export default function StepsReloadOverlay(): JSX.Element | null {
    const steps = useStepsContext();
    return steps?.reloading ? <div className={SAVING_OVERLAY_CLASS} /> : null;
}
